$(function() {
    const manageLoginToggle = function () {
        let toggleLoginActive = 0;
        const $body = $('body');
        const $loginBtn = $('.authenticatedButton');
        const $loginToggleBox = $('#loginToggleBox');
        let loginBtn;
        let loginToggleBox;

        let manageFilterOuterClick = function (triggerBtn) {
            loginBtn = triggerBtn[0];
            loginToggleBox =  $loginToggleBox[0];
            $(document).on('click', function( event ) {
                if (toggleLoginActive && loginBtn !== event.target && !loginBtn.contains(event.target) && loginToggleBox !== event.target && !loginToggleBox.contains(event.target)) {
                    closeLoginToggle();
                    return false;
                }
            });
        }

        const openLoginToggle = function (triggerBtn) {
            $loginBtn.attr('aria-expanded', 'true');
            $loginToggleBox.addClass('activeBox');
            $loginToggleBox.prop('inert', false);
            toggleLoginActive = 1;
            manageFilterOuterClick(triggerBtn);
            if (!Revealizr.isDesktopSize) {
                $body.addClass('overflow-hidden');
            }
            TINK.updateStatusNotification(window['loginPannelOpenMessage']);
            TINK.trapFocus($loginToggleBox, closeLoginToggle);
        }

        const closeLoginToggle = function () {
            $loginBtn.attr('aria-expanded', 'false');
            $loginToggleBox.removeClass('activeBox');
            $loginToggleBox.prop('inert', true);
            toggleLoginActive = 0;
            if (!Revealizr.isDesktopSize) {
                $body.removeClass('overflow-hidden');
            }
            TINK.updateStatusNotification(window['loginPannelCloseMessage']);
            $('.authenticatedButton').focus();
        }

        let triggerLoginBtn;
        $loginBtn.on('click', function() {
            triggerLoginBtn = $(this);
            if (toggleLoginActive) {
                closeLoginToggle();
            } else {
                openLoginToggle(triggerLoginBtn);
            }
        });
        $('.close-login-box').on('click', function() {
            closeLoginToggle();
        });
    }

    manageLoginToggle();
});